import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';

export default {
    fields: {
        site_version: {
            component: LinkTitleComponent,
        },
        domain: {},
        company_name: {},
    },
    sortable: [],
    filterable: [],
    pagination: false,
    searchable: false,
    treeView: false,
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.settings.js